'use strict';

module.exports = inlineHeaders;

var encode = require('querystring-es3/encode');

function inlineHeaders(url, headers) {
  if (/\?/.test(url)) {
    url += '&';
  } else {
    url += '?';
  }

  return url + encode(headers);
}



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/algoliasearch/src/browser/inline-headers.js